import { render, staticRenderFns } from "./notOpened.vue?vue&type=template&id=5f8ad934&scoped=true"
import script from "./notOpened.vue?vue&type=script&lang=js"
export * from "./notOpened.vue?vue&type=script&lang=js"
import style0 from "./notOpened.vue?vue&type=style&index=0&id=5f8ad934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ad934",
  null
  
)

export default component.exports